import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { BillingSubscriptionProduct } from './types/Subscriptions';

const getSubscriptionTenantProducts = (makeCall: MakeCall) => () =>
  makeCall<BillingSubscriptionProduct>(
    'GET',
    `${APIV2_URL}/billing/subscriptions/tenant-products`,
  );

export default getSubscriptionTenantProducts;
